import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

import './SearchBar.css'

interface SearchBarProps {
	value?: string
	placeholder?: string
	onChange?: (value: string) => void
	onSubmit?: (value: string) => void
}

const DEFAULT_PLACEHOLDER =
	'Recherche (par lieu, noms, programmes, numéro de lots, promoteurs, etc...)'

function SearchBar(props: SearchBarProps) {
	const handleSubmit = () => props.onSubmit?.(props.value ?? '')

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key !== 'Enter') return
		event.preventDefault()
		handleSubmit()
	}

	return (
		<div className='search-bar'>
			<input
				type='text'
				placeholder={props.placeholder ?? DEFAULT_PLACEHOLDER}
				value={props.value}
				onChange={event => props.onChange?.(event.target.value)}
				onKeyDown={handleKeyDown}
			/>
			<button
				type='button'
				className='search-button'
				aria-label='Rechercher'
				onClick={handleSubmit}
			>
				<FontAwesomeIcon icon={faMagnifyingGlass} />
			</button>
		</div>
	)
}

export default SearchBar
